import {mergeToHierarchy} from '#core/utils/config-utils.js';

import {AbstractVisualFeature, allVisuals} from '#core/application/modules/visual-feature.js';

import {getVideoStreamingConfig} from './factory.js';

import SCHEMA from './video-streaming.schema.yaml';
import PALETTE_SCHEMA from './video-streaming.palette-schema.yaml';

class VideoStreamingFeature extends AbstractVisualFeature {
    get name() {
        return 'Presentation/VideoStreaming';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        const {autoPlayStreamDesktop, autoPlayStreamMobile, hidePlayerWhenStreamEnded, rmg} = this.config;

        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            VideoStream: {
                _desktop_autoPlayStream: autoPlayStreamDesktop,
                _mobile_autoPlayStream: autoPlayStreamMobile,
                hidePlayerWhenStreamEnded: hidePlayerWhenStreamEnded,
                rmgConfig: {
                    src: rmg.src,
                    'data-cssdiff': rmg.dataCssDiff,
                    'data-csspath': rmg.dataCssPath,
                    'data-responsive': rmg.dataResponsive,
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }

    getVisualConfig(PALETTE) {
        return getVideoStreamingConfig(PALETTE);
    }
}

export const VideoStreaming = new VideoStreamingFeature(allVisuals);
